export default {
  loading: false,
  createLoading: false,
  record: {}
}
